import { call, put, take } from 'redux-saga/effects';

import { userInstrumentsServices, userInstrumentsSlice } from '!core/redux';
import { handleSagaError } from '»utils/handleSagasError';

const setFavInstrumentWorker = function* ({
  option,
  instrument,
  symbol,
  exchange,
  securityType,
}) {
  try {
    yield call(userInstrumentsServices.setUserFavoriteInstrument, {
      option,
      instrument,
      symbol,
      exchange,
      securityType,
    });

    yield put(
      userInstrumentsSlice.actions.setFavInstrumentSuccess({
        option,
        instrument,
        symbol,
        exchange,
        securityType,
      }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(
        userInstrumentsSlice.actions.setFavInstrumentFailure({
          error: error[0].detail,
        }),
      );
  }
};

const setFavInstrumentSagas = function* () {
  while (true) {
    try {
      const data = yield take(
        userInstrumentsSlice.actions.setFavInstrumentRequest.type,
      );

      const { option, instrument, symbol, exchange, securityType } =
        data.payload;

      yield call(setFavInstrumentWorker, {
        option,
        instrument,
        symbol,
        exchange,
        securityType,
      });
    } catch (error) {
      yield put(
        userInstrumentsSlice.actions.setFavInstrumentFailure({
          error: error[0].detail,
        }),
      );
    }
  }
};

export { setFavInstrumentSagas };
